import { useMemo, type ReactElement } from 'react';
import { usePageBreadcrumb, usePageSidebar } from '@/hooks';
import { sidebarItems } from './sidebar';
import { ROUTES } from '@/constants';
import { SectionIntro, SectionTitle } from '@/components';
import { Link } from 'react-router-dom';

export const OrganismosInternacionales = (): ReactElement => {
	usePageBreadcrumb([
		{ label: 'Información', to: ROUTES.INFORMACION_BUSCADOR_NOTARIOS },
		{ label: 'Corporación Notarial', to: ROUTES.INFORMACION_ORGANISMOS_INTERNACIONALES },
		{ label: 'Organismos Internacionales' },
	]);

	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	return (
		<div>
			<SectionTitle title="Organismos Internacionales" tag="h1" align="left" className="u-mb-16" />
			<SectionIntro text="Aquí encontrará enlaces a las Organizaciones Internacionales de interés de nuestro colectivo." />
			<div className="o-strapi-page">
				<ul className="u-mt-16">
					<li>
						<Link to="https://www.notariesofeurope.eu/en/" target="_blank">
							CNUE
						</Link>
					</li>
					<li>
						<Link to="https://uinl.org/" target="_blank">
							UINL
						</Link>
					</li>
				</ul>
			</div>
		</div>
	);
};
